import React, {useEffect} from 'react';
import {GPSResponse} from '../types/vwCelebration';

type PolylineProps = {
  map?: google.maps.Map;
  maps: any;
  gpsData?: GPSResponse;
};

const Polyline: React.FC<PolylineProps> = ({map, maps, gpsData}) => {
  useEffect(() => {
    if (!map || !maps || !gpsData?.positions?.length) {
      return;
    }

    const path = gpsData?.positions.map((pos) => ({
      lat: pos.t,
      lng: pos.g,
    }));

    const polyline = new maps.Polyline({
      path,
      strokeColor: gpsData?.drawRanges[0].event.colour,
      strokeOpacity: 1,
      strokeWeight: 2,
    });
    polyline.setMap(map);
  }, [gpsData, map, maps]);

  return null;
};

export default Polyline;
